module.exports = __webpack_public_path__ + "41d2ac53a9abe1d45ba55b58bd255016.MP3";